import Container from 'react-bootstrap/Container'

import CinemaSelect from './components/CinemaSelect/CinemaSelect'
import Copyright from './components/Copyright/Copyright'
import FooterLinks from './components/FooterLinks/FooterLinks'
import LogoSocials from './components/LogoSocials/LogoSocials'

import './Footer.scss'
import ProjectInfo from './components/ProjectInfo/ProjectInfo'

const Footer = ({ toggleChooseCineama, chosenCinema }) => {
    return (
        <footer className={'footer'}>
            <Container fluid className="footer--content d-flex gap-6">
                <LogoSocials />
                <ProjectInfo />
                <div className={'footer--links d-flex flex-column'}>
                    <CinemaSelect toggleChooseCineama={toggleChooseCineama} chosenCinema={chosenCinema} />

                    <FooterLinks />
                </div>
            </Container>
            <Copyright />
        </footer>
    )
}

export default Footer
